import { Page } from "../page";

export class DownloadMergeFileRequset extends Page {
  docReference: string[] | null;
  docTypes: string[] | null;
  referenceKeys: string[] | null;
  remarks: string[] | null;
  downloadFunction: string | null;

  constructor() {
    super();
    this.docReference = null;
    this.docTypes = null;
    this.referenceKeys = null;
    this.remarks = null;
    this.downloadFunction = null;
  }
}
